export interface UniLayoutState {
  isLoader: boolean;
}

export const initialState: UniLayoutState = {
  isLoader: false,
};
